import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from 'View/Component/ScrollToTop/ScrollToTop';
import HomePage from 'View/Pages/HomePage/HomePage';
import ShopListingPage from 'View/Pages/ShopListingPage/ShopListingPage';
import WatchDetailPage from 'View/Pages/WatchDetailPage/WatchDetailPage';
import CartPage from 'View/Pages/CartPage/CartPage';
import CheckoutAddressPage from 'View/Pages/CheckoutAddressPage/CheckoutAddressPage';
import CheckoutReviewPage from 'View/Pages/CheckoutReviewPage/CheckoutReviewPage';
import CheckoutConfirmationPage from 'View/Pages/CheckoutConfirmationPage/CheckoutConfirmationPage';
import SellPage from 'View/Pages/SellPage/SellPage';
import RequestPage from 'View/Pages/RequestPage/RequestPage';
import AboutPage from 'View/Pages/AboutPage/AboutPage';
import ShowroomPage from 'View/Pages/ShowroomPage/ShowroomPage';
import ContactPage from 'View/Pages/ContactPage/ContactPage';
import ImprintPage from 'View/Pages/Legal/ImprintPage';
import PrivacyPage from 'View/Pages/Legal/PrivacyPage';
import TermsPage from 'View/Pages/Legal/TermsPage';
import RevocationPage from 'View/Pages/Legal/RevocationPage';
import ShippingPage from 'View/Pages/Legal/ShippingPage';
import PaymentPage from 'View/Pages/Legal/PaymentPage';
import ShortLinkRedirectPage from 'View/Pages/ShortLinkRedirectPage/ShortLinkRedirectPage';
import NotFoundPage from 'View/Pages/NotFoundPage/NotFoundPage';
import { GoogleAnalyticsTracker } from 'View/Component';

const Router: React.FC = () => {
  return (
    <>
      <GoogleAnalyticsTracker />
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/s/:code" element={<ShortLinkRedirectPage />} />
      <Route path="/watches" element={<ShopListingPage />} />
      <Route path="/kaufen" element={<ShopListingPage />} />
      <Route path="/kaufen/:slug" element={<WatchDetailPage />} />
      <Route path="/warenkorb" element={<CartPage />} />
      <Route path="/checkout/adresse" element={<CheckoutAddressPage />} />
      <Route path="/checkout/uebersicht" element={<CheckoutReviewPage />} />
      <Route path="/checkout/bestaetigung" element={<CheckoutConfirmationPage />} />
      <Route path="/verkaufen" element={<SellPage />} />
      <Route path="/suchanfrage" element={<RequestPage />} />
      <Route path="/uber-mich" element={<AboutPage />} />
      <Route path="/showroom" element={<ShowroomPage />} />
      <Route path="/kontakt" element={<ContactPage />} />
      <Route path="/impressum" element={<ImprintPage />} />
      <Route path="/datenschutz" element={<PrivacyPage />} />
      <Route path="/agb" element={<TermsPage />} />
      <Route path="/widerruf" element={<RevocationPage />} />
      <Route path="/versand" element={<ShippingPage />} />
      <Route path="/zahlung" element={<PaymentPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </>
  );
};

export default Router;
